import React, {FC, ReactNode} from 'react';

export const FloatingWrapper: FC<{children: ReactNode}> = ({children}) => {
    if (!children) {
        return null;
    }

    return (
        <div className='absolute right-3 top-1/2 z-[11] m-0 flex -translate-y-1/2 gap-2 p-0 rtl:left-3 rtl:right-auto md:rtl:right-auto'>
            {children}
        </div>
    );
};
